import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './sidebarComponent.module.css';
import {
    basePageUrl, faqPageUrl, fontCreatorPageUrl, offerPageUrl, oldBasePageUrl
} from '../../../helpers/urls';

type PropsType = {
  toggleSidebar: () => void;
  AuthContent?: ReactNode;
  StatsContent?: ReactNode;
};

export const SidebarComponent: FC<PropsType> = ({ toggleSidebar, AuthContent, StatsContent }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('fixed flex flex-col justify-between w-250 top-0 left-0 bottom-0 bg-white border-r border-gray z-[51] p-16', styles.container)}>
        <div className="flex items-center absolute right-[6px] top-[6px] h-[32px] w-[32px] cursor-pointer" onClick={toggleSidebar}>
            <div className="absolute h-[3px] w-full bg-black rotate-45" />
            <div className="absolute h-[3px] w-full bg-black -rotate-45" />
        </div>
        <div className="mt-32">
            <div className="flex items-center justify-between mb-16">
                {AuthContent}
            </div>
            <div className="-mx-16">
                <a href={basePageUrl} className="block py-10 px-16 border-b border-gray">{t('sidebar.noteGenerator')}</a>
                <a href={oldBasePageUrl} className="block py-10 px-16 border-b border-gray">{t('sidebar.oldNoteGenerator')}</a>
                <a href={fontCreatorPageUrl} className="block px-16 py-10 border-b border-gray">{t('sidebar.fontGenerator')}</a>
                <a href={offerPageUrl} className="block px-16 py-10 border-b border-gray">{t('sidebar.offer')}</a>
                <a href={faqPageUrl} className="block px-16 py-10">{t('sidebar.faq')}</a>
            </div>
        </div>
        <div className="mt-32">
            {StatsContent}
            {t('sidebar.socials')}
            <a href="https://vk.com/pisaka.online" target="_blank" className="flex">
                <div className={styles.vkLogo} />
            </a>
        </div>
    </div>
  );
};
